import React, { useContext } from 'react';
import VideoPreview from './VideoPreview';
import ExpanderContainer from './ExpanderContainer';
import { Footage, IncidentType, reviewFootage, ReviewFootageInput, ReviewStatus } from './ApiClient';
import { useDebounce } from './hooks/useDebounce';
import { ModalContext } from './ModalContext';
// import { Modal, Button } from 'react-bootstrap';
interface IncidentViewerProps {
    footage: Footage & { isSelected: boolean };
    onIncidentUpdated?: (footage: any) => void;
    playbackRate?: number | undefined;
}

export default function IncidentViewer(props: IncidentViewerProps) {
    const { modalState, updateState } = useContext(ModalContext);
    const { footage, playbackRate } = props;
    const { review_status, reviewed_notes, incident_type, footage_id, isSelected } = footage;

    
    const hoverClass = 'incident-viewer' + (footage.camera.isHighlighted ? ' highlight' : '');

    function formatBytes(bytes, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GiB', 'TB', 'PiB', 'EiB', 'ZiB', 'YiB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }

    function openVideo() {
        window.open(`/WebAPI/PlayVideo?videoId=${footage.footage_id}&tag=true`, "_blank", "noreferrer");
    }

    async function incidentClicked(event) {
        const value = event.target.value;
        if (value != undefined) {
            let rs = value as ReviewStatus;
            if (review_status === value) {
                rs = ReviewStatus.PendingEvaluation;
            }

            const updatedFootage: ReviewFootageInput = {
                footage_id,
                reviewed_notes,
                incident_type,
                review_status: rs
            };
            const result = await reviewFootage(updatedFootage);

            props.onIncidentUpdated({
                ...footage,
                review_status: rs,
            });
        }
    }

    const updateNotesDebounce = useDebounce((input: ReviewFootageInput) => {
        const result = reviewFootage(input);
    }, 500);

    async function onNotesChanged(event) {
        const value = event.target.value;

        props.onIncidentUpdated({
            ...footage,
            reviewed_notes: value,
        });

        if (value != undefined) {
            const rs = value as ReviewStatus;

            const updatedFootage: ReviewFootageInput = {
                footage_id,
                reviewed_notes: value,
                incident_type,
                review_status,
            };
            const result = await reviewFootage(updatedFootage);
            updateNotesDebounce(updatedFootage);

        }
    }

    async function onIncidentTypeChanged(event) {
        const value = event.target.value;
        if (value != undefined) {
            const rs = value as ReviewStatus;
            const updatedFootage: ReviewFootageInput = {
                footage_id,
                reviewed_notes,
                incident_type: value,
                review_status,
            };
            const result = await reviewFootage(updatedFootage);

            props.onIncidentUpdated({
                ...footage,
                incident_type: value,
            });
        }
    }

    return (
        <div className={hoverClass}>
            <div className="incident-radio-container">
                <div className="form-check">
                    <label className="form-check-label" htmlFor={`incidentCheck-${footage_id}`}>
                        Incident
                    </label>

                    <input className="form-check-input input-incident" type="checkbox" value={ReviewStatus.Incident} data-footageid={footage_id} id={`incidentCheck-${footage_id}`} checked={review_status == ReviewStatus.Incident} onChange={incidentClicked} />
                </div>
                <div className="form-check no-incident" style={{ textAlign: 'right' }}>
                    <label className="form-check-label" htmlFor={`noincidentCheck-${footage_id}`}>
                        No Incident
                    </label>
                    <input className="form-check-input pull-right input-no-incident" type="checkbox" value={ReviewStatus.NoIncident} id={`noincidentCheck-${footage_id}`} checked={review_status == ReviewStatus.NoIncident} onChange={incidentClicked} />
                </div>
            </div>
            <ExpanderContainer isExpanded={review_status == ReviewStatus.Incident}>
                <div className="edit-panel">
                    <select className="input-incident-type" value={incident_type} onChange={onIncidentTypeChanged} data-footageid={footage_id}>
                        <option value={IncidentType.None}>Choose Incident Type</option>
                        <option value={IncidentType.IncidentAccident}>Accident</option>
                        <option value={IncidentType.IncidentAftermath}>Aftermath</option>
                        <option value={IncidentType.IncidentOther}>Incident - Other</option>
                    </select>
                    <input type="text" placeholder="Notes (Customer viewable)" value={footage.reviewed_notes} onChange={onNotesChanged}></input>
                </div>

            </ExpanderContainer>

            <div className="video-viewer-container">
                <VideoPreview playbackRate={playbackRate} footage={footage} />
            </div>

            {footage.camera_type === 0 && <div className="full-video">
                <a className="btn play-video-btn videolink"
                    // @ts-ignore
                    onClick={() => updateState({
                        show: true,
                        id: footage.footage_id,
                        data: footage,
                    })}
                // href={`/WebAPI/PlayVideo?videoId=${footage.footage_id}`}
                // data-videoid={footage.footage_id}
                // data-showreviewcontrols="true"
                // data-timezone="America/New_York"
                // data-videodate="2024-11-25T12:51:09.0000000Z"
                // data-basefile={`/WebAPI/PlayVideo?videoId=${footage.footage_id}`}
                // data-title="(116919--2) November 25, 2024 7:51:09 AM EST TEST"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="1" y="1" width="22" height="22" rx="1" stroke="white" strokeWidth="2" />
                        <path d="M9.5 6H17.5V13" stroke="white" strokeWidth="2" />
                        <path d="M6.5 16.5L16.5 6.5" stroke="white" strokeWidth="2" />
                    </svg>
                    &nbsp;
                    Play Full Video
                </a>
            </div>}
            <div className="metadata">
                <div className="metadata-row">
                    <div className="metadata-label">Video</div>
                    <div className="metadata-value"><a href="#" onClick={() => updateState({
                        show: true,
                        id: footage.footage_id,
                        data: footage,
                    })}>{footage.footage_id}</a>
                    {footage.user_downloaded && <span className="badge bg-info ms-1" title="A user has downloaded this video">Downloaded</span>}
                    </div>
                </div>
                <div className="metadata-row">
                    <div className="metadata-label">Location</div>
                    <div className="metadata-value">{footage.camera?.label} ({footage.camera?.jurisdiction})</div>
                </div>
                <div className="metadata-row">
                    <div className="metadata-label">
                        When
                        {/* <br />
                        ({footage.timezone_local}): */}
                    </div>
                    <div className="metadata-value">
                        {footage.when} ({footage.duration})
                    </div>
                </div>
                <div className="metadata-row">
                    <div className="metadata-label">Size</div>
                    <div className="metadata-value">{footage?.width}x{footage?.height} ({formatBytes(footage.file_size)})</div>
                </div>
                {footage.camera_type === 0 &&
                    <div className="metadata-row">
                        <div className="metadata-label">Avg. FPS</div>
                        <div className="metadata-value">{footage.fps}</div>
                    </div>
                }
                {footage.camera_type === 1 &&
                    <div className="metadata-row">
                        <div className="metadata-label">Refresh</div>
                        <div className="metadata-value">{footage.refresh}</div>
                    </div>
                }
                <div className="metadata-row">
                    <div className="metadata-label">Camera</div>
                    <div className="metadata-value"><a href={`/Dashboard/FindFootage?cameraId=${footage.camera_id}&searchdate=${footage.start_date_utc}`} target="_blank">{footage.camera_id} {footage.camera.isHighlighted}</a></div>
                </div>
            </div>
            <div className="download-recording-container">
                <button onClick={() => openVideo()} className="btn download-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22" fill="none">
                        <g clipPath="url(#clip0_438_290)">
                            <path d="M0 11.9088C0.0880469 11.4993 0.146016 11.0812 0.268516 10.682C0.880469 8.68955 2.2132 7.33721 4.13438 6.52419C4.3843 6.41859 4.64297 6.32053 4.90711 6.2645C5.14828 6.21332 5.24344 6.0894 5.30633 5.86634C5.67984 4.53502 6.35195 3.36748 7.34563 2.38906C8.87797 0.879933 10.7505 0.106784 12.8964 0.0103427C15.2666 -0.0963357 17.3622 0.621319 19.1286 2.20533C19.7668 2.77752 20.2973 3.43806 20.708 4.18589C20.8102 4.37177 20.9163 4.43211 21.1334 4.40679C22.651 4.22953 24.0023 4.64708 25.1814 5.58456C26.6394 6.74401 27.458 8.28331 27.8327 10.0699C27.8966 10.3759 27.9448 10.6852 28 10.9928V12.2859C27.8852 12.8091 27.8108 13.3446 27.6478 13.8527C27.0408 15.7476 25.7255 16.9889 23.8995 17.7723C22.733 18.2728 21.5272 18.4307 20.2738 18.3439C20.2475 18.3423 20.2218 18.3299 20.1797 18.3186V16.7136C20.4181 16.7136 20.6451 16.6953 20.8682 16.7168C21.7591 16.802 22.5788 16.559 23.3795 16.2136C24.6794 15.6533 25.6211 14.7573 26.0673 13.4087C26.448 12.2584 26.4403 11.0925 26.1155 9.93521C25.7786 8.73373 25.1814 7.6788 24.1845 6.87817C23.4216 6.26612 22.5427 5.89813 21.5622 6.01451C20.9617 6.08563 20.3541 6.30329 19.8084 6.57107C19.1373 6.90026 18.5265 7.3496 17.891 7.74884C17.8073 7.80164 17.7308 7.86521 17.6345 7.93579C17.2752 7.53117 16.923 7.13409 16.5572 6.72192C17.3496 5.98272 18.2202 5.37875 19.2418 4.9057C19.0509 4.63361 18.8907 4.36584 18.6922 4.12878C17.1445 2.27968 15.1304 1.47475 12.7285 1.65201C10.8145 1.79317 9.21758 2.59756 8.01445 4.09807C7.29258 4.99783 6.89773 6.04091 6.67953 7.15564C6.5975 7.57589 6.60187 7.57589 6.14414 7.65078C5.11 7.8205 4.16609 8.19387 3.36055 8.86842C0.909453 10.9217 1.05055 14.6447 4.11031 16.2524C4.71516 16.5703 5.355 16.7378 6.04789 16.7179C6.67516 16.7001 7.30352 16.7141 7.95484 16.7141V18.31C7.94719 18.3154 7.93242 18.3348 7.91766 18.3348C6.59422 18.3262 5.24727 18.5239 3.97852 17.983C1.77023 17.0412 0.372969 15.4593 0.0464844 13.0537C0.0410156 13.0122 0.0158594 12.9728 0 12.9324C0 12.5914 0 12.2498 0 11.9088Z" fill="white" />
                            <path d="M14.726 18.8788C14.8868 18.6897 15.0476 18.5011 15.2078 18.3115C15.6388 17.8012 16.0653 17.2872 16.5023 16.7813C16.8506 16.3778 17.3401 16.3191 17.7065 16.6224C18.0707 16.9241 18.0959 17.4117 17.7513 17.8217C16.6718 19.1078 15.5901 20.3917 14.5035 21.6718C14.1436 22.0959 13.5825 22.1142 13.2227 21.6928C12.1262 20.4095 11.0412 19.1159 9.96166 17.819C9.66525 17.4629 9.72486 16.9602 10.0623 16.6838C10.4205 16.3913 10.9088 16.4295 11.2315 16.8013C11.7286 17.374 12.2099 17.9602 12.6982 18.5399C12.7885 18.6471 12.8803 18.7527 13.0313 18.8438C13.0313 18.7409 13.0313 18.638 13.0313 18.5356C13.0373 16.0944 13.0466 13.6537 13.0471 11.2125C13.0471 10.837 13.1286 10.5169 13.4934 10.3305C14.0173 10.0627 14.6402 10.3925 14.6681 10.9841C14.6998 11.6554 14.6806 12.3294 14.6796 13.0023C14.6768 14.8961 14.6724 16.7894 14.6692 18.6832C14.6692 18.7414 14.6692 18.7996 14.6692 18.8578C14.6883 18.8648 14.7074 18.8718 14.7266 18.8788H14.726Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_438_290">
                                <rect width="28" height="22" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    &nbsp;
                    Download Recording</button>
            </div>
        </div>
    );
}
